export const TABLE_MODAL_INNER_ID = 'table-modal-inner';

export const getTableModalInner = () => document.getElementById(TABLE_MODAL_INNER_ID) || false;

export const getTimesheetPopupContainer = (triggerNode: any) => {
  const tableModalInner = getTableModalInner();

  return tableModalInner || triggerNode.parentElement;
};
